import _createForOfIteratorHelper from '@babel/runtime/helpers/esm/createForOfIteratorHelper';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _applyDecoratedDescriptor from '@babel/runtime/helpers/esm/applyDecoratedDescriptor';
import { NamedShortcut, extension, command, NodeExtension, ExtensionTag, toggleBlockItem, CommandsExtension, object, setBlockType } from '@remirror/core';
import { textblockTypeInputRule } from '@remirror/pm/inputrules';
import { ExtensionHeadingMessages } from '@remirror/messages';

var LABEL = ExtensionHeadingMessages.LABEL;
/**
 * Command options for the heading.
 */

var toggleHeadingOptions = {
  icon: _ref => {
    var _attrs$level;

    var attrs = _ref.attrs;
    return "h".concat((_attrs$level = attrs === null || attrs === void 0 ? void 0 : attrs.level) !== null && _attrs$level !== void 0 ? _attrs$level : '1');
  },
  label: _ref2 => {
    var t = _ref2.t,
        attrs = _ref2.attrs;
    return t(LABEL, {
      level: attrs === null || attrs === void 0 ? void 0 : attrs.level
    });
  }
};
/**
 * The named shortcuts for the default 6 levels of commands.
 */

var shortcuts = [NamedShortcut.H1, NamedShortcut.H2, NamedShortcut.H3, NamedShortcut.H4, NamedShortcut.H5, NamedShortcut.H6];

var _dec, _dec2, _class, _class2;
var HeadingExtension = (_dec = extension({
  defaultOptions: {
    levels: [1, 2, 3, 4, 5, 6],
    defaultLevel: 1
  },
  staticKeys: ['defaultLevel', 'levels']
}), _dec2 = command(toggleHeadingOptions), _dec(_class = (_class2 = class HeadingExtension extends NodeExtension {
  get name() {
    return 'heading';
  }

  createTags() {
    return [ExtensionTag.Block, ExtensionTag.TextBlock, ExtensionTag.FormattingNode];
  }

  createNodeSpec(extra, override) {
    var _override$parseDOM;

    return _objectSpread(_objectSpread({
      content: 'inline*',
      defining: true,
      draggable: false
    }, override), {}, {
      attrs: _objectSpread(_objectSpread({}, extra.defaults()), {}, {
        level: {
          default: this.options.defaultLevel
        }
      }),
      parseDOM: [...this.options.levels.map(level => ({
        tag: "h".concat(level),
        getAttrs: element => _objectSpread(_objectSpread({}, extra.parse(element)), {}, {
          level
        })
      })), ...((_override$parseDOM = override.parseDOM) !== null && _override$parseDOM !== void 0 ? _override$parseDOM : [])],
      toDOM: node => {
        if (!this.options.levels.includes(node.attrs.level)) {
          // Use the first level available
          return ["h".concat(this.options.defaultLevel), extra.dom(node), 0];
        }

        return ["h".concat(node.attrs.level), extra.dom(node), 0];
      }
    });
  }
  /**
   * Toggle the heading for the current block. If you don't provide the
   * level it will use the options.defaultLevel.
   */


  toggleHeading() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return toggleBlockItem({
      type: this.type,
      toggleType: 'paragraph',
      attrs
    });
  }
  /**
   * Dynamically create the shortcuts for the heading extension.
   */


  createKeymap(fn) {
    var commandsExtension = this.store.getExtension(CommandsExtension);
    var keys = object();
    var attrShortcuts = [];

    var _iterator = _createForOfIteratorHelper(this.options.levels),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _shortcuts;

        var level = _step.value;

        var _shortcut = (_shortcuts = shortcuts[level - 1]) !== null && _shortcuts !== void 0 ? _shortcuts : NamedShortcut.H1;

        keys[_shortcut] = setBlockType(this.type, {
          level
        }); // Dynamically add the attribute specific shortcut to the array of
        // attribute shortcuts.

        attrShortcuts.push({
          attrs: {
            level
          },
          shortcut: fn(_shortcut)[0]
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    commandsExtension.updateDecorated('toggleHeading', {
      shortcut: attrShortcuts
    });
    return keys;
  }

  createInputRules() {
    return this.options.levels.map(level => {
      return textblockTypeInputRule(new RegExp("^(#{1,".concat(level, "})\\s$")), this.type, () => ({
        level
      }));
    });
  }

  createPasteRules() {
    return this.options.levels.map(level => ({
      type: 'node',
      nodeType: this.type,
      regexp: new RegExp("^#{".concat(level, "}\\s([\\s\\w]+)$")),
      getAttributes: () => ({
        level
      }),
      startOfTextBlock: true
    }));
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "toggleHeading", [_dec2], Object.getOwnPropertyDescriptor(_class2.prototype, "toggleHeading"), _class2.prototype)), _class2)) || _class);

export { HeadingExtension };
